/**
 * dir-w | backOffice
 * Overlay properties
 *
 * Type
 * - Loading
 * - Display
 *
 * Title
 * Content
 * UseButton
 * Last update : September 8, 2024 | @rizkiprasetya
 */


import { Component, Input } from '@angular/core';
import { enumOverlayMode, enumOverlayTextColor } from '../../app.enum';
import { Configuration } from '../../config/configuration';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrl: './overlay.component.css',
    standalone: false
})
export class OverlayComponent {
  protected _enumOverlayMode = enumOverlayMode;
  protected _enumOverlayTextColor = enumOverlayTextColor;

  // get the image based on active profile on `Configuration`
  protected profilePath: string = `/assets/profile/${Configuration.Profile}/images/background.png`;

  @Input() mode: enumOverlayMode = enumOverlayMode.LOADING; // show default loading
  @Input() color: enumOverlayTextColor = enumOverlayTextColor.NORMAL;
  @Input() loadingText: string = 'Loading . . .';

}
